'use client';

import { createContext, useContext, type ReactNode } from 'react';

export const TRACE_NAVIGABLE_ENTITY_TYPES = [
  'endpoint',
  'webpage',
  'signal',
  'finding',
  'execution',
] as const;

export type TraceNavigableEntityType =
  (typeof TRACE_NAVIGABLE_ENTITY_TYPES)[number];

export type TraceEntityNavigationTarget = {
  type: TraceNavigableEntityType;
  id: string;
  label?: string;
};

export type TraceEntityNavigationHandler = (
  target: TraceEntityNavigationTarget,
) => void;

const TraceEntityNavigationContext =
  createContext<TraceEntityNavigationHandler | null>(null);

export type TraceEntityNavigationProviderProps = {
  onOpenEntity: TraceEntityNavigationHandler;
  children: ReactNode;
};

export function TraceEntityNavigationProvider({
  onOpenEntity,
  children,
}: TraceEntityNavigationProviderProps) {
  return (
    <TraceEntityNavigationContext.Provider value={onOpenEntity}>
      {children}
    </TraceEntityNavigationContext.Provider>
  );
}

export function useTraceEntityNavigation():
  | TraceEntityNavigationHandler
  | undefined {
  return useContext(TraceEntityNavigationContext) ?? undefined;
}
